import { __awaiter } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useMemo } from "react";
import { AttributeDataType, } from "@plansoft-configuration-renderer/configuration-api";
import { DefaultDoubleFormatOptionsContext, DefaultIntegerFormatOptionsContext, NumberFormatOptionsContext, useEventCallback, } from "@plansoft-configuration-renderer/utils";
import { CsAttributeApiContext } from "../context/CsAttributeApiContext";
import { CsAttributeContext } from "../context/CsAttributeContext";
import { useCsConfigurationApi } from "../hooks/useCsConfigurationApi";
/**
 * Provide attribute and attribute update mechanism to the react tree below
 * @category Controller
 * @category CsAttribute
 * @param props
 */
export function CsAttributeController(props) {
    var _a;
    const { children, attribute } = props;
    const { setAttributeValue, setLocalAttributeValue, setAttributeValueQuantity, resetAttributes, } = useCsConfigurationApi();
    const integerNumberFormatOptions = useContext(DefaultIntegerFormatOptionsContext);
    const doubleNumberFormatOptions = useContext(DefaultDoubleFormatOptionsContext);
    const defaultNumberFormatOptions = attribute.dataType === AttributeDataType.Integer
        ? integerNumberFormatOptions
        : doubleNumberFormatOptions;
    const numberFormatOptions = (_a = props.numberFormatOptions) !== null && _a !== void 0 ? _a : defaultNumberFormatOptions;
    const attributeId = attribute.id;
    const attributePath = attribute.path;
    const isEditable = Boolean(attribute.isEditable);
    const isMultiValued = Boolean(attribute.isMultiValued);
    const setValue = useEventCallback((value) => __awaiter(this, void 0, void 0, function* () {
        yield setAttributeValue({
            attributePath,
            isEditable,
            isMultiValued,
            attributeId,
            value,
        });
    }));
    const setLocalValue = useEventCallback((value) => {
        setLocalAttributeValue({
            attributePath,
            isEditable,
            isMultiValued,
            attributeId,
            value,
        });
    });
    const setValueQuantity = useEventCallback((value, quantity) => __awaiter(this, void 0, void 0, function* () {
        yield setAttributeValueQuantity({
            attributePath,
            attributeId,
            value,
            quantity,
        });
    }));
    const resetAttribute = useEventCallback(() => __awaiter(this, void 0, void 0, function* () {
        yield resetAttributes([
            {
                attributeId,
                attributePath: attributePath,
            },
        ]);
    }));
    const toggleOption = useEventCallback((value, valueSelected) => __awaiter(this, void 0, void 0, function* () {
        yield setAttributeValue({
            isEditable,
            isMultiValued,
            attributePath,
            attributeId,
            value,
            valueSelected,
        });
    }));
    const api = useMemo(() => ({
        setValue,
        setLocalValue,
        toggleOption,
        setValueQuantity,
        resetAttribute,
    }), [setValue, setLocalValue, toggleOption, setValueQuantity, resetAttribute]);
    return (_jsx(CsAttributeContext.Provider, { value: attribute, children: _jsx(CsAttributeApiContext.Provider, { value: api, children: _jsx(NumberFormatOptionsContext.Provider, { value: numberFormatOptions, children: children }) }) }));
}
//# sourceMappingURL=CsAttributeController.js.map